/* ═══════════════════════════════════════════════════════
   PG Cart Subscription Upsell — switch handler

   Loaded globally from layout/theme.liquid, NOT from the
   snippet. Horizon morphs the cart drawer via the Section
   Rendering API, and morph.js only re-executes scripts
   matching `.shopify-app-block script[src]` — an inline
   <script> inside a morphed snippet is inserted but never
   run, so the handler has to already exist on window.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* Collect the cart section IDs currently on the page */
  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* Highlight the savings line on the line item that was just switched.
     The savings markup itself is server-rendered on every subscription
     line, so this only draws attention to it — it never creates it. */
  function highlightSaving() {
    /* Not scoped to .cart-drawer — cart-products.liquid also renders the
       banner on the /cart page, which has no drawer ancestor. */
    var savings = document.querySelectorAll('[data-pg-saving]');
    if (!savings.length) return;
    /* The switched foam line is the last subscription line re-added */
    var target = savings[savings.length - 1];
    target.classList.add('pg-cart-saving--switched');
  }

  /* Re-render the drawer. /cart/add.js's `sections` param is
     unreliable, so sections are fetched separately. */
  function refreshCartDrawer(onDone) {
    var sectionIds = getSectionIds();

    if (!sectionIds.length) {
      location.reload();
      return;
    }

    fetch('/?sections=' + sectionIds.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        sectionIds.forEach(function (secId) {
          if (!sections[secId]) return;
          var cartComp = document.querySelector(
            'cart-items-component[data-section-id="' + secId + '"]'
          );
          if (!cartComp) return;
          var doc = new DOMParser().parseFromString(sections[secId], 'text/html');
          var newContent = doc.querySelector('cart-items-component');
          if (newContent) cartComp.innerHTML = newContent.innerHTML;
        });
        if (typeof onDone === 'function') onDone();
      })
      .catch(function () { location.reload(); });

    /* Update the cart count in the header */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* count refresh is non-critical */ });
  }

  function track(planId) {
    var trackData = {
      event: 'pg_subscription_upsell',
      plan_id: planId,
      source: 'cart_drawer'
    };

    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish('pg_subscription_upsell', trackData);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(trackData);

    if (window.omnisend) {
      window.omnisend.push(['track', 'subscription_upsell_clicked']);
    }

    document.dispatchEvent(new CustomEvent('pg:subscription-upsell', { detail: trackData }));
  }

  /* Called via inline onclick — bypasses Horizon's <dialog>
     event propagation blocking. */
  window.pgSubUpsellSwitch = function (lineKey, variantId, planId) {
    var banner = document.getElementById('pg-sub-upsell');
    if (!banner || banner.classList.contains('pg-sub-upsell--swapping')) return;

    banner.classList.add('pg-sub-upsell--swapping');

    track(planId);

    /* /cart/change.js cannot add a selling_plan to an existing
       line — the item has to be removed and re-added. */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Remove failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1,
              selling_plan: parseInt(planId, 10)
            }]
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        refreshCartDrawer(highlightSaving);
      })
      .catch(function (err) {
        console.error('[PG Upsell]', err);
        /* Refresh anyway so the drawer isn't left stuck */
        refreshCartDrawer();
      });
  };
})();
